// @flow
export const changeMenu = (payload: string) => {
  return {
    type: 'CHANGE_MENU',
    payload
  };
};



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/